import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=06bcb16c&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=06bcb16c&scoped=true&lang=css&"
import style1 from "./nav.vue?vue&type=style&index=1&id=06bcb16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcb16c",
  null
  
)

export default component.exports